export default {
  arrowButtonBorderBottom: Styles.color.grey.four,
  arrowButtonColor: '',
  arrowButtonFill: Styles.color.black,
};
